import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@pulse/ui';

export interface RemoveConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

// Generic "Remove X?" confirmation for any permanent-delete action — the caller composes
// title/description from its own domain data (e.g. an attachment's label, a linked issue's key)
// and owns the "which item is pending removal" state. Used by IssueDetailDialog (issue links),
// ProjectRequestsPage (attachments), and AttachmentsPanel (attachment delete across Risks,
// Dependencies, Escalations, Change Requests) — reach for this instead of hand-rolling another
// Cancel/Remove confirm dialog.
export function RemoveConfirmDialog({ open, title, description, isPending, onCancel, onConfirm }: RemoveConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ wordBreak: 'break-word' }}>{title}</DialogTitle>
      <DialogContent>
        <Typography>{description}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isPending}>
          Cancel
        </Button>
        <Button color="error" variant="contained" onClick={onConfirm} disabled={isPending}>
          {isPending ? 'Removing…' : 'Remove'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
